// extracted by mini-css-extract-plugin
module.exports = {"_search":"SearchInput__search__16flV","_input":"SearchInput__input__1uYFs"};